// eslint-disable-next-line import/no-anonymous-default-export
export default [
    { value: "PEN", label: "Pendiente" },
    { value: "EIR", label: "EIR" },
    { value: "COR", label: "Corte Demoras" },
    { value: "CNA", label: "Confirmación Naviera" }, 
    { value: "TER", label: "Terminado" },  
  ];
